exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".container{color:#fff;display:flex;flex-direction:column;align-items:center;justify-content:space-between;height:75%}.container h2{color:#fff}@media(max-width:992px){.container h2{font-size:20px}}.container p{font-size:23px;font-weight:500;text-align:center;width:575px;line-height:30px}@media(max-width:992px){.container p{width:100%;padding:0 20px;font-size:12px}}", ""]);

// exports
